
import React,{useState,useRef,useEffect} from 'react';
import Canvas from '../component/vectors/canvas';
import {Grid,Cell, TextField,SelectionControl} from 'react-md';
import arrowSVG from '../images/vectors/upper-right-arrow.svg';


const colors = ['#F79722','#0AAAFA','#FF5500','#09B83E','#34465D','#E4405F']

const vectorList = [{
        x: 5,
        y: 5,
        name: `1`,
        color: colors[0],
        angleOptions:{
            angleOffset:0,
            type:1
        }
    }, {
        x: 10,
        y: 5,
        name: `2-a`,
        color: colors[1],
        altText: 'testing',
        angleOptions:{
            angleOffset:0,
            type:2,
            clockwise:false
        }
    },
    {
        x: 5,
        y: 5,
        name: `\\vec C-1`,
        color: colors[3],
        type: 2,
        direction: 'in'
    },
    {
        x: 5,
        y: 5,
        name: `3`,
        color: colors[0],
        angleOptions:{
            angleOffset:180,
            type:3
        }
    },
    {
        x: 10,
        y: 5,
        name: `2-b`,
        color: colors[1],
        altText: 'testing',
        angleOptions:{
            angleOffset:0,
            type:2,
            clockwise:true
        }
    },
    {
        x: 5,
        y: 5,
        name: `\\vec C-2`,
        color: colors[3],
        type: 2,
        direction: 'out'
    }
    
];

// const freeBodyDiagram = {
//     src:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAawAAAB9CAYAAAD+3VeSAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAJGSURBVHhe7djBacNAEEBRbSpxGSokDfjuc8At5Jwy0qNimw1uYT96D8TOWbD6jMbxsAHA4j7mCQBLEywAEgQLgATBAiBBsABIECwAEgQLgATBAiBBsABIECwAEgQLgATBAiBBsABIECwAEgQLgATBAiBBsABIECwAEgQLgATBAiBBsABIECwAEgQLgATBAiBBsABIECwAEgQLgATBAiBBsABIECwAEgQLgATBAiBBsABIECwAEgQLgATBAiBBsABIECwAEgQLgATBAiBBsABIECwAEgQLgATBAiBBsABIECwAEgQLgATBAiBBsFje/X7fxhine67X63wDwNM4HuYMS3p+vM/K9YQ3wWJ5/8H6+f58nWdw+/p9na4nvPklCECCYAGQIFgAJAgWAAmCBUCCYAGQIFgAJAgWAAmCBUCCYAGQIFgAJAgWAAmCBUCCYAGQIFgAJAgWAAmCBUCCYAGQIFgAJAgWAAmCBUCCYAGQIFgAJAgWAAmCBUCCYAGQIFgAJIzjYc6wpDHGnM7H9YQ3GxbL2/d9TudyuVzmBDzZsABIsGEBkCBYACQIFgAJggVAgmABkCBYACQIFgAJggVAgmABkCBYACQIFgAJggVAgmABkCBYACQIFgAJggVAgmABkCBYACQIFgAJggVAgmABkCBYACQIFgAJggVAgmABkCBYACQIFgAJggVAgmABkCBYACQIFgAJggVAgmABkCBYACQIFgAJggVAgmABkCBYACQIFgAJggVAgmABkCBYACQIFgAB2/YHuGAlL983LJQAAAAASUVORK5CYII=',
//     x:50,
//     y:50,
// };
const Test1 = () => {
    const [vectors,setVectors] = useState([]);
    const [isAngle,setIsAngle]= useState(true);
    const mathJaxElem = useRef(null);
    const canvasRef = useRef(null);
    const selectedVectorIndex = useRef(-1);

    useEffect(()=>{
        console.log(document.querySelector("#MathJax-Element-1-Frame > svg"));
    },[mathJaxElem]);

    const onVectorMoved = (props) => {
        
        const {index,...rest} = props;
        if(isNaN(rest.x))
            return;
        selectedVectorIndex.current = index;
        console.log(props);
        setVectors(vectors.map((el,elIndex) => {
            if(index ===elIndex )
               return Object.assign({}, rest)
            return el
        })); 
    }


    const selectedvector =  selectedVectorIndex.current > -1 && vectors[selectedVectorIndex.current] ? vectors[selectedVectorIndex.current] : {};
    const {x,y} =  selectedvector ? selectedvector : {};
    const index = selectedVectorIndex.current;

    const addVector = (index) => {
        if(vectorList[index].isAdded){
            const temp  =  vectorList[index];
            const tempVector = [];
            vectors.forEach((el) => {
                if(temp.name !== el.name )
                    tempVector.push(el);   
            });
            canvasRef.current.drawVectors({vectors:tempVector});
            setVectors(tempVector);
            vectorList[index].isAdded = false;
        }else{
            const tempVectors = [...vectors,{...vectorList[index]}]
            canvasRef.current.drawVectors({vectors:tempVectors});
            setVectors([...tempVectors]);
            vectorList[index].isAdded = true;
        }
    }
    
    const updateFromText = (vector,index) => {
        if(isNaN(vector.x) || isNaN(vector.y))
            return;
        setVectors(vectors.map((el,elIndex) => {
            if(index ===elIndex )
               return Object.assign({}, vector)
            return el
        })); 
    }

  

    const calcAngleDegrees = (x, y,selectedvector) => {
        if(!selectedvector || selectedvector.type !== 1)
            return;
        console.log('selectedvector',selectedvector);
        const {angleOptions:{type}} = selectedvector;
        const angle = Math.atan2(y, x) * 180 / Math.PI;
        const angleSigned = type !== 3?Math.abs(angle):angle;
        if (isAngle)
            return Math.round(angleSigned);
        else
            return angleSigned.toFixed(1);
    }

    const calculateMagnitude = (x, y) => {
        const mag = Math.sqrt(Math.pow(x,2) + Math.pow(y,2));        
        if (isAngle)
            return Math.round(mag);
        else
            return mag.toFixed(2);
    }

    
    return <Grid>
                <Cell size={3}>
                    <TextField floating	label='a_x' placeholder='a_x' onChange={(xVal)=>updateFromText({...selectedvector,x:parseInt(xVal,10)},index)} value={x!==undefined?isAngle?x.toFixed(2):x.toFixed(0):''}/>
                </Cell>
                <Cell size={3}>
                    <TextField floating	label='a_y' placeholder='a_y'onChange={(yVal)=>updateFromText({...selectedvector,y:parseInt(yVal,10)},index)} value={y!==undefined?isAngle?y.toFixed(2):y.toFixed(0):''}/>
                </Cell>
                <Cell size={3}>
                    <TextField floating	label='magnitude' placeholder='magnitude'  value={y!==undefined && x !== undefined ? calculateMagnitude(x,y):''}/>
                </Cell>
                <Cell size={3}>
                    <TextField floating	label='angle' placeholder='angle'  value={y!==undefined && x !== undefined ?calcAngleDegrees(x,y,selectedvector):''}/>
                </Cell>
                <Cell size={8}>
                    <Canvas ref={canvasRef}  degStepSize={5} magStepSize={1} height={500} width={500} stepSize={20} enableGrid={true} enableRuler={false} vectors={vectors} onVectorMoved={onVectorMoved} stepDeg={isAngle}></Canvas>
                </Cell>
                <Cell size={4}>
                    <Grid>
                        <Cell size={12}>
                            <div className='arrow-container'>
                                <div className='arrow-container-child' onClick={()=>{addVector(0)}}>
                                    <img src={arrowSVG} className='arrow-svg' alt='a'></img>
                                    &nbsp;
                                    &nbsp;
                                    &nbsp;
                                    $$Option 1$$
                                </div>
                                <div className='arrow-container-child' onClick={()=>{addVector(1)}}>
                                    <img src={arrowSVG} className='arrow-svg' alt='a'></img>
                                    &nbsp;
                                    &nbsp;
                                    &nbsp;
                                    $$Option 2$$
                                </div>
                                <div className='arrow-container-child' onClick={()=>{addVector(2)}}>
                                    <img src={arrowSVG} className='arrow-svg' alt='a'></img>
                                    &nbsp;
                                    &nbsp;
                                    &nbsp;
                                    $$\vec C$$
                                </div>
                                <div className='arrow-container-child' onClick={()=>{addVector(3)}}>
                                    <img src={arrowSVG} className='arrow-svg' alt='a'></img>
                                    &nbsp;
                                    &nbsp;
                                    &nbsp;
                                    $$Option 3$$
                                </div>
                                <div className='arrow-container-child' onClick={()=>{addVector(4)}}>
                                    <img src={arrowSVG} className='arrow-svg' alt='a'></img>
                                    &nbsp;
                                    &nbsp;
                                    &nbsp;
                                    $$Option 2-b$$
                                </div>
                                <div className='arrow-container-child' onClick={()=>{addVector(5)}}>
                                    <img src={arrowSVG} className='arrow-svg' alt='a'></img>
                                    &nbsp;
                                    &nbsp;
                                    &nbsp;
                                    $$C-2$$
                                </div>
                            </div>
                        </Cell>
                        <Cell size={12}>
                            <SelectionControl
                                id="switch-angle"
                                type="switch"
                                label="Angle"
                                name="angle"
                                onChange={(checked)=>setIsAngle(checked)}
                            />
                        </Cell>
                    </Grid>
                </Cell>
            </Grid>
}

export default Test1;